import { formatApiDate } from '~/shared/lib/date'
type MinimalTask = { isComplete: boolean }
type MinimalFormSubmission = {
  completedAt?: string | null
  expiredAt?: string | null
  startedAt?: string | null
}

// Probably good enough
// https://stackoverflow.com/a/34405528
const getTimeZoneAbbreviation = () =>
  new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]

export const formatDateTimeDay = (dateTime: string) => formatApiDate(dateTime, 'MMM. d, yyyy') ?? ''
export const formatDateTimeFull = (dateTime: string) =>
  (formatApiDate(dateTime, 'MMM. d, yyyy h:mm a') ?? '') + ' ' + getTimeZoneAbbreviation()

export const getTaskStatus = (task: MinimalTask) => (task.isComplete ? 'Complete' : 'Incomplete')

export const getFormSubmissionStatus = (submission: MinimalFormSubmission) => {
  if (submission.completedAt) {
    return 'Complete'
  }
  if (submission.expiredAt) {
    return 'Expired'
  }
  if (!submission.startedAt) {
    return 'Not Started'
  }
  if (!submission.completedAt) {
    return 'In Progress'
  }
  return 'Unknown'
}
